import { useSessionMetadata } from '@/hooks/useSessionMetadata'

export function useCurrentCompanyUser() {
  const sessionMetadata = useSessionMetadata()

  return sessionMetadata?.currentCompanyUser
}
